export let TownsquareScope = /*#__PURE__*/function (TownsquareScope) {
  TownsquareScope["TownsquareProject"] = "townsquare.project";
  TownsquareScope["TownsquareGoal"] = "townsquare.goal";
  TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
  TownsquareScope["TownsquareTag"] = "townsquare.tag";
  TownsquareScope["TownsquareLearning"] = "townsquare.learning";
  TownsquareScope["People"] = "townsquare.people";
  TownsquareScope["Teams"] = "townsquare.teams";
  return TownsquareScope;
}({});